export function applyColor(mainCtx, color) {
    mainCtx.strokeStyle = color;
    mainCtx.shadowColor = color;
}
export default function useColorPicker(event, onSelect) {
    const colorPicker = document.getElementById("color-picker");
    if (!colorPicker)
        return;
    const edgePadding = 82;
    const left = Math.min(Math.max(event.clientX, edgePadding), window.innerWidth - edgePadding);
    const top = Math.min(Math.max(event.clientY, edgePadding), window.innerHeight - edgePadding);
    colorPicker.style.left = `${left}px`;
    colorPicker.style.top = `${top}px`;
    colorPicker.classList.remove("hidden");
    const closePicker = () => {
        colorPicker.classList.add("hidden");
        colorPicker.removeEventListener("click", onColorSliceClick);
        colorPicker.removeEventListener("mouseleave", onMouseLeave);
        window.removeEventListener("keydown", onKeyDown);
    };
    const onColorSliceClick = (event) => {
        const target = event.target.closest(".color-slice");
        const selectedColor = target === null || target === void 0 ? void 0 : target.dataset.color;
        if (!selectedColor)
            return;
        onSelect(selectedColor);
        closePicker();
    };
    const onMouseLeave = (event) => {
        const relatedTarget = event.relatedTarget;
        if (!(relatedTarget instanceof Node) ||
            !colorPicker.contains(relatedTarget))
            closePicker();
    };
    const onKeyDown = (event) => {
        if (event.key === "Escape")
            closePicker();
    };
    colorPicker.addEventListener("click", onColorSliceClick);
    colorPicker.addEventListener("mouseleave", onMouseLeave);
    window.addEventListener("keydown", onKeyDown);
}
